import { render } from "./PressList.vue?vue&type=template&id=75a36590"
import script from "./PressList.vue?vue&type=script&lang=js"
export * from "./PressList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\Logica Yachts\\Front\\Logica-Yachts\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__